import { render, staticRenderFns } from "./orderDetailModal.vue?vue&type=template&id=1ad31800&scoped=true&"
import script from "./orderDetailModal.vue?vue&type=script&lang=js&"
export * from "./orderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailModal.vue?vue&type=style&index=0&id=1ad31800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad31800",
  null
  
)

export default component.exports